import { render, staticRenderFns } from "./StarSnowFlakes.vue?vue&type=template&id=bdce2b7c&"
import script from "./StarSnowFlakes.vue?vue&type=script&lang=js&"
export * from "./StarSnowFlakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports